import { i18n } from '@/plugins/i18n'

export const userStatus = {
    ACTIVE: 1,
    BLOCK: 0,
    PENDING: 2,
    REMOVED: 3,
    IS_AUTHENTICATED: 4,
    IS_AUTHENTICATED_PENDING: 5,
    REMOVED_WHEN_PENDING: 6,
    REMOVED_WHEN_IS_AUTHENTICATED: 7,
    REMOVED_WHEN_IS_AUTHENTICATED_PENDING: 8,
    AUTHORIZATION_DOCUMENTS_REJECTED: 9,
    REMOVED_WHEN_IS_AUTHORIZATION_DOCUMENTS_REJECTED: 10,
    ENAMAD_AUTHENTICATED: 11,
    TEMPORARY_BLOCK: 14,
    USER_INQUIRY_REJECTED: 12,
    DEACTIVATED: 13,
}

export const userStatusStr = {
    ACTIVE: i18n.t('user_status.active'),
    BLOCK: i18n.t('user_status.block'),
    PENDING: i18n.t('user_status.pending'),
    REMOVED: i18n.t('user_status.removed'),
    IS_AUTHENTICATED: i18n.t('user_status.is_authenticated'),
    IS_AUTHENTICATED_PENDING: i18n.t('user_status.is_authenticated_pending'),
    REMOVED_WHEN_PENDING: i18n.t('user_status.removed_when_pending'),
    REMOVED_WHEN_IS_AUTHENTICATED: i18n.t('user_status.removed_when_is_authenticated'),
    REMOVED_WHEN_IS_AUTHENTICATED_PENDING: i18n.t('user_status.removed_when_is_authenticated_pending'),
    AUTHORIZATION_DOCUMENTS_REJECTED: i18n.t('user_status.authorization_documents_rejected'),
    REMOVED_WHEN_IS_AUTHORIZATION_DOCUMENTS_REJECTED: i18n.t('user_status.removed_when_is_authorization_documents_rejected'),
    ENAMAD_AUTHENTICATED: i18n.t('user_status.enamad_authenticated'),
    TEMPORARY_BLOCK: i18n.t('user_status.temporary_block'),
    USER_INQUIRY_REJECTED: i18n.t('user_status.user_inquiry_rejected'),
    DEACTIVATED: i18n.t('user_status.deactivated'),
    get(status) {
        let status_str = null;
        Object.keys(userStatus).forEach(function (item, index) {
            if(userStatus[item] === status) {
                status_str = userStatusStr[item]
            }
        })

        return status_str
    }
}

export const userVariant = (status) => {
    return (status === userStatus.ACTIVE || status === userStatus.IS_AUTHENTICATED) 
        ? 'success' 
        : (
            (status === userStatus.PENDING || status === userStatus.IS_AUTHENTICATED_PENDING || status === userStatus.AUTHORIZATION_DOCUMENTS_REJECTED)
            ? 'warning'
            : 'danger'
        )
} 